module.exports = __webpack_public_path__ + "media/images/session-background-sp-8fa9c519e7500eea2292ed3e32bc7d2b.png";